import { Battery } from "lucide-react";
import { BatteryFull } from "lucide-react";
import { BatteryMedium } from "lucide-react";
import { BatteryWarning } from "lucide-react";
import { BatteryLow } from "lucide-react";
import React from "react";

export function Icone_batterie({
  niveau_batterie,
}: {
  niveau_batterie?: number | null;
}) {
  let bat_couleur = "grey";
  let bat_icone = "battery-exclamation";
  let icone = <BatteryWarning className={"grey"} />;

  if (!niveau_batterie) {
    return <></>;
  }

  if (niveau_batterie <= 5) {
    bat_couleur = "red";
    bat_icone = "battery-empty";
    icone = <Battery className={"red"} />;
  } else if (niveau_batterie <= 15) {
    bat_couleur = "orange";
    bat_icone = "battery-low";
    icone = <BatteryLow className={"orange"} />;
  } else if (niveau_batterie <= 25) {
    bat_couleur = "orange";
    bat_icone = "battery-quarter";
    icone = <BatteryLow className={"orange"} />;
  } else if (niveau_batterie <= 50) {
    bat_couleur = "green";
    bat_icone = "battery-half";
    icone = <BatteryMedium className={"green"} />;
  } else if (niveau_batterie <= 75) {
    bat_couleur = "green";
    bat_icone = "battery-three-quarters";
    icone = <BatteryFull className={"green"} />;
  } else if (niveau_batterie > 75) {
    bat_couleur = "green";
    bat_icone = "battery-full";
    icone = <BatteryFull className={"green"} />;
  }
  return (
    <>{icone}</>

    // <Icone className={bat_couleur} nom={bat_icone}/>
  );
}
